// Components
import { Popover, List, Persona, ListItem, PopoverSurface, mergeClasses } from "@fluentui/react-components";
import { UserContainer } from "../user/UserContainer";
// Constants
import { AtMentionPickerListId } from "@ms/uno-constants/lib/local/ChatConstants";
// Styles
import { useAtMentionPickerStyles } from "./AtMentionPicker.styles";
// Utilities
import React, { useEffect } from "react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { getMentionUserListItemId } from "../../../utilities/ChatAtMentionsUtilities";
/**
 * AtMentionPicker displays a list of users that can be mentioned in a chat message.
 */ export function AtMentionPicker({ targetElement, mountNode, mentionableUsers, highlightedItemIndex = 0, onUserSelected, getUserPhoto, onRenderPersona }) {
    const positioningRef = React.useRef(null);
    const [isPositioned, setIsPositioned] = React.useState(false);
    useEffect(()=>{
        if (positioningRef.current) {
            positioningRef.current.setTarget(targetElement);
            // Only show popover after positioning with target element to prevent flicker
            setIsPositioned(true);
        }
    }, [
        targetElement
    ]);
    const userListItemOnAction = (ev, data)=>{
        const userId = data.value;
        const user = mentionableUsers.find((u)=>u.id === userId);
        if (user) {
            onUserSelected(user);
        }
    };
    const styles = useAtMentionPickerStyles();
    const renderUserListItem = (user, index)=>{
        const isHighlighted = index === highlightedItemIndex;
        const avatarImgSrc = getUserPhoto(user.id) ?? undefined;
        return /*#__PURE__*/ React.createElement(ListItem, {
            id: getMentionUserListItemId(index),
            className: mergeClasses(styles.userListItem, isHighlighted ? styles.highlightedListItem : ""),
            key: user.id,
            value: user.id,
            onAction: userListItemOnAction,
            role: "option",
            "aria-selected": isHighlighted
        }, /*#__PURE__*/ React.createElement(UserContainer, {
            user: user,
            onLoad: onRenderPersona,
            containerId: `userContainer-atMentionPicker-${user.id}`
        }, /*#__PURE__*/ React.createElement(Persona, {
            name: user.displayName,
            secondaryText: user.isGuest() ? Strings.TaskAssignments_PersonaRoleGuest : user.userPrincipalName,
            avatar: {
                image: {
                    src: avatarImgSrc
                }
            }
        })));
    };
    return /*#__PURE__*/ React.createElement(Popover, {
        open: isPositioned,
        positioning: {
            positioningRef
        },
        mountNode: mountNode
    }, /*#__PURE__*/ React.createElement(PopoverSurface, {
        className: styles.popoverSurface
    }, mentionableUsers.length === 0 && /*#__PURE__*/ React.createElement("div", {
        className: styles.noUsersMessage
    }, Strings.TaskChat_AtMentionPickerNoSuggestions), mentionableUsers.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, Strings.TaskChat_AtMentionPickerTitle), /*#__PURE__*/ React.createElement(List, {
        id: AtMentionPickerListId,
        role: "listbox"
    }, mentionableUsers.map(renderUserListItem)))));
}
